<template>
    <div class="temp-wrap" >
        <div class="main-title">
            <h1>商品SGS{{all_questions.questions_report.title}} <span> PDF下載 </span></h1>
        </div>
        <div class="bottom-list-wrap" >
            <ul class="custom-scroller">
                <li class="report-list">
                    <div class="item-wrap" v-for="(pdf, id) in all_questions.questions_report.pdfs">
                        <div class="img-wrap">
                            <img :src="pdf.img" alt="" >
                        </div>
                        <div class="name">{{pdf.title}}</div>
                        <a :href="pdf.download_url" target="_blank">
                        <button class="download-btn" :class="`pdf-download-id${id}`">下載PDF</button>
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
// _mCS_3 mCS_no_scrollbar
//  mCS_y_hidden mCS_no_scrollbar_y
import ct_scroll from './function.js'

export default {
    props: ["all_questions"],
    methods: {
        ga_func(class_name, name){
            $("body").on('click', class_name, function (e) {
                //alert()
                gtag('event', '點擊', {
                    'event_category': name,
                    'event_action': '點擊',
                    'event_label': '點擊次數'
                });
            });
        }
    },
    mounted(){

        this.all_questions.questions_report.pdfs.forEach((e ,id)=>{
            //console.log(e.id)
            this.ga_func(".pdf-download-id"+id, "常見問題-檢驗報告-"+e.title)+"pdf";
        });
        ct_scroll();

    }

}
</script>
<style lang="sass">
.report-list
    .img-wrap
        position: relative
        overflow: hidden
        padding-bottom: 60%
        img
            position: absolute
            width: 100%
            left: 50%
            top: 50%
            transform: translate(-50%, -50%)
        @media (max-width: 768px)
            height: 190px
            padding-bottom: unset
        @media (max-width: 576px)
            height: 170px
            img
                width: 70% !important
                min-width: 200px !important

</style>



// WEBPACK FOOTER //
// src/Qna/report.vue